import _ from 'underscore';

import { ConversionFilterOption } from '@bingads-webui-campaign/overview-cards-common';

export function getPropsFromPreferenceForConversionTracking({
  preferenceService,
  responsiveSize,
  campaignType,
}) {
  return {
    preferenceService,
    responsiveSize,
    campaignType,
  };
}

export function getHeaderPropsFromPreferenceForConversionTracking({
  i18n,
}) {
  return ({
    options: [
      {
        value: ConversionFilterOption.AllChanges,
        displayName: i18n.getString(_TL_('All changes')),
      },
      {
        value: ConversionFilterOption.TopGainers,
        displayName: i18n.getString(_TL_('Top gainers')),
      },
      {
        value: ConversionFilterOption.TopDecliners,
        displayName: i18n.getString(_TL_('Top decliners')),
      },
    ],
    initialSelectedValue: ConversionFilterOption.AllChanges,
    // we are not using preference in conversion tracking card now.
    onOptionSelected: _.noop,
  });
}
